import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { DatePicker } from "../ui/date-picker";
import { parseISO, format } from "date-fns";

interface FormModalProps {
  columns: Array<{ field: string; label: string; type?: string }>;
  onClose: () => void;
  onSubmit: (data: any) => void;
}

export default function FormModal({ columns, onClose, onSubmit }: FormModalProps) {
  const [formData, setFormData] = useState<any>(() => {
    const initial: any = {};
    columns.forEach((col) => {
      initial[col.field] = "";
    });
    return initial;
  });

  const handleChange = (field: string, value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  const getInputType = (type?: string) => {
    switch (type) {
      case "number":
        return "number";
      case "date":
        return "date";
      default:
        return "text";
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Novo Registro</DialogTitle>
          <DialogDescription>
            Preencha os campos abaixo para adicionar um novo registro
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            {columns.length === 0 ? (
              <div className="text-center py-8 text-muted-foreground">
                <p>Nenhum campo disponível para cadastro.</p>
                <p className="text-sm mt-1">
                  Configure as colunas no componente conectado.
                </p>
              </div>
            ) : (
              columns.map((col) => (
                <div key={col.field} className="space-y-2">
                  <Label htmlFor={col.field}>{col.label}</Label>
                  {col.type === "textarea" ? (
                    <Textarea
                      id={col.field}
                      value={formData[col.field] || ""}
                      onChange={(e) => handleChange(col.field, e.target.value)}
                      rows={3}
                    />
                  ) : col.type === "date" ? (
                    <DatePicker
                      date={formData[col.field] ? parseISO(formData[col.field]) : undefined}
                      onDateChange={(date) => handleChange(col.field, date ? format(date, "yyyy-MM-dd") : "")}
                      placeholder="Select date"
                    />
                  ) : (
                    <Input
                      id={col.field}
                      type={getInputType(col.type)}
                      value={formData[col.field] || ""}
                      onChange={(e) => handleChange(col.field, e.target.value)}
                    />
                  )}
                </div>
              ))
            )}
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" disabled={columns.length === 0}>
              Adicionar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
